import { render, staticRenderFns } from "./OutputSearchStrategy.vue?vue&type=template&id=6a2596d7&scoped=true"
import script from "./OutputSearchStrategy.vue?vue&type=script&lang=js"
export * from "./OutputSearchStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2596d7",
  null
  
)

export default component.exports